import { ComponentsCustomer } from "@omni/types/components/customer/customer.model";
import { useState } from "react";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { Messages } from "@/components/General/Messages/messages.container";
import { Modal } from "@/components/General/Modal/modal";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { noEmptyValueFormatter } from "@/utils/textUtils";

type Props = {
    title?: string;
    text?: string;
    customer: ComponentsCustomer;
    removeBonusCard: () => void;
    isLoading: boolean;
};

const EditForm = ({
    text,
    title,
    customer,
    removeBonusCard,
    isLoading
}: Props) => {
    const { t } = useGranite();
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const bonusCardNumber =
        customer.eBonusCardNumber || customer.bonusCardNumber;

    return (
        <>
            {title && <h4>{title}</h4>}
            {text && <div dangerouslySetInnerHTML={{ __html: text }} />}

            <Messages messageid={"bonuscard-feedback-failure"} />
            <Messages messageid={"bonuscard-feedback-success"} />

            <Row>
                <Col
                    xs={6}
                    md={3}
                >
                    <p>{t("profileDetails.label.bonuscard")}</p>
                </Col>
                <Col>
                    <p>
                        {noEmptyValueFormatter(
                            bonusCardNumber,
                            bonusCardNumber
                        )}{" "}
                        {!customer.eBonusCardNumber && (
                            <button
                                type={"button"}
                                className="ml-2 ml-md-3 btn btn-link p-0"
                                onClick={() => setIsOpen(true)}
                            >
                                <i className="las la-trash-alt la-lg" />
                                {t("profileDetails.label.bonuscard.remove")}
                            </button>
                        )}
                    </p>
                </Col>
            </Row>
            <Modal
                open={isOpen}
                title={t("profileDetails.label.bonuscard.remove.modal.title")}
                confirmButtonText={t(
                    "profileDetails.label.bonuscard.remove.modal.label"
                )}
                isLoading={isLoading}
                confirmButtonColor={"danger"}
                onConfirm={removeBonusCard}
                setOpen={setIsOpen}
            />
        </>
    );
};

export default EditForm;
